import { useState, useEffect } from 'react';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';

import Loader from '@/components/Loader/Loader';
import ErrorMessage from '@/components/Error/ErrorMessage';
import { ensureString } from '@/lib/ensureTypes';

import type { Props as PublicProjectDetailProps } from '@/components/Project/PublicProjectDetail';

const PublicProjectDetailComponent = dynamic<PublicProjectDetailProps>(
  () =>
    import(/* webpackChunkName: "public_project_detail" */ '@/components/Project/PublicProjectDetail')
      .then((mod) => mod.PublicProjectDetail),
  {
    ssr: false,
    loading: () => <Loader />,
  }
);

type Props<T = {}> = T;

const ProjectPage = (_props: Props) => {
  const router = useRouter();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(false);
  }, []);

  const projectId: string | null = ensureString(
    router.query.projectId
  );

  // validation error
  if (projectId === null) {
    return (
      <ErrorMessage />
    );
  }

  return isLoading ? (
    <Loader />
  ) : (
    <PublicProjectDetailComponent projectId={projectId} />
  );
};

export default ProjectPage;
